import { GET_USER_SUCCESS, LOGOUT } from '../Utils/Constants';

const initialState = {
    username: '',
    isLoggedIn: false
}

export const userReducer = (state = initialState, action) => {
    switch(action.type) {

        case GET_USER_SUCCESS:
            return {
                username: action.payload.username,
                isLoggedIn: true
            }

        case LOGOUT:
            return {
                username: '',
                isLoggedIn: false
            }

        default:
            return state;
    }
}
